import React, { Component } from 'react';
import { Grid, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Edit extends Component {

  state = {
    set_name: this.props.set_name,
    tamil_name: this.props.tamil_name,
    status: this.props.status,
    priority: this.props.priority,
    id: this.props.id,
    data: this.props.data,
    load: false,
    message: '',
    set_names: []
  };

  componentDidMount() {
    this.setAllModel();
  }

  setAllModel() {
    let context = this;
    var x = [];
    let menu = ['Active', 'Inactive'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        set_names: x,
      });
    } catch (e) {}
  }


  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  status = (f, { value }) => {
    this.setState({ status: value })
  }

  cancel() {
    this.props.handleClose();
  }

  update() {
    let context = this;
    context.setState({
      load: true,
      message: 'Updating Model Details'
    });
    let set_name = this.state.set_name;
    let tamil_name = this.state.tamil_name;
    let status = this.state.status;
    let id = this.state.id;
    let oldData = this.state.data;
    let priority = this.state.priority;

    if (set_name == '' || set_name == null || set_name == undefined) {
      context.setState({
        error: 'Enter Assembly name field!!!',
      });
      return;
    }

    if (tamil_name == '' || tamil_name == null || tamil_name == undefined) {
      context.setState({
        error: 'Enter Tamil name field!!!',
      });
      return;
    }

    if (priority == '' || priority == null || priority == undefined) {
      context.setState({
        error: 'Enter priority field!!!',
      });
      return;
    }

    let data1 = { 'set_name': set_name, 'status': status, 'id': id, 'tamil_name': tamil_name, 'priority': priority };

    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/setdetails/update.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        if (data == 1) {
          for (var i = 0; i < oldData.length; i++) {
            if (id == oldData[i].id) {
              oldData[i].set_name = set_name;
              oldData[i].status = status;
              oldData[i].tamil_name = tamil_name;
              oldData[i].priority = priority;
            }
          }
          context.props.updateData(oldData);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    let { load, message, set_names, status } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Assembly Name<br/>
            <Input focus value={this.state.set_name}
                onChange={this.onChange('set_name')}
                placeholder='Assembly Name' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Tamil Name<br/>
            <Input focus value={this.state.tamil_name}
                onChange={this.onChange('tamil_name')}
                placeholder='Tamil Name' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Status<br/>
            <Dropdown style={{ borderColor: '#5A9CBB' }}
             fluid selection onChange={this.status}
             options={set_names} value={status} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
          Priority<br/>
          <Input focus value={this.state.priority}
              onChange={this.onChange('priority')}
              placeholder='Priority' style={{ borderColor: '#5A9CBB' }}
              fluid />
          </Grid.Column>

          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.update.bind(this)}>Save</Button>
          </Grid.Column>
        </Grid>
        <Loading load={load} message={message} />
      </div>
    );
  }
}

export default Edit;
